'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import a$1 from "../defs/ArrowArcLeft.es.js";
const o = a.forwardRef((e, t) => /* @__PURE__ */ a.createElement(p, { ref: t, ...e, weights: a$1 }));
o.displayName = "ArrowArcLeftIcon";
const s = o;
export {
  s as ArrowArcLeft,
  o as ArrowArcLeftIcon
};
